import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '@src/model';
import { Modal } from '@ss/mtd-react-mobile';
import { isString, isFunction } from '@block/utils';
import classnames from 'classnames';
import { Popup } from 'antd-mobile';
import useGo from '@utils/navigate';
import { LxSiteClick } from '@utils/siteLx';
import { SECTION_NAME_MAP } from '@model/content';
import NavBar from './NavBar';
import './index.scss';

const menuIcon = (
  <svg fill="none" version="1.1" width="24" height="24" viewBox="0 0 24 24" className="menu">
    <g>
      <rect x="4" y="5" width="16" height="2" rx="1" fill="#000000" />
    </g>
    <g>
      <rect x="4" y="11" width="16" height="2" rx="1" fill="#000000" />
    </g>
    <g>
      <rect x="4" y="17" width="9" height="2" rx="1" fill="#000000" />
    </g>
  </svg>
);

// 获取Title文案
function getText({
  isShowCampusText,
  isShowSocialText,
  isShowBeidouText,
  isShowQihangText,
  text,
  isShowLogo,
  setIsShowTipsDialog,
}) {
  // 显示校招Title
  if (isShowCampusText || isShowSocialText || isShowBeidouText || isShowQihangText) {
    let title = '';
    if (isShowCampusText) {
      title = '校园招聘';
    }
    if (isShowSocialText) {
      title = '社会招聘';
    }
    if (isShowBeidouText) {
      title = '北斗计划';
    }
    if (isShowQihangText) {
      title = '零售启航计划';
    }
    return (
      <div
        className="textWrap"
        onClick={() => {
          setIsShowTipsDialog(true);
        }}
      >
        <span>{title}</span>
        <i className="iconfont-official-website-m icon-zp-mtdui-info-circle-o tipsIcon" />
      </div>
    );
  }

  if (isShowLogo) {
    return (
      <div className="textWrap">
        <img
          crossOrigin="anonymous"
          className="textWrap_img"
          src="//s3plus.meituan.net/zhaopin-official-website-mobile-prod/common/logo.png"
          alt=""
        />
      </div>
    );
  }
  const isStringOfText = isString(text);
  // 显示自定义的文案Title
  if (isStringOfText) {
    return <div className="textWrap">{text}</div>;
  }
  // 显示自定义dom Title
  if (text) {
    return text;
  }
  return null;
}

interface IProps {
  children?: React.ReactNode;
  isShowBack?: boolean;
  isShowMenu?: boolean;
  isShowCampusText?: boolean;
  isShowSocialText?: boolean;
  isShowBeidouText?: boolean;
  isShowQihangText?: boolean;
  text?: string | React.ReactNode;
  isShowLogo?: boolean;
  isShowSearch?: boolean;
  searchPlaceHolder?: string;
  isSticky?: boolean;
  searchValue?: string;
  searchInputOnChangeCbFn?: Function;
  searchCallbackFn?: Function;
  bgColor?: string;
  isShowPersonalCenter?: boolean;
  backUrl?: string; // 指定点击返回进入到当前路由
  defaultBackUrl?: string; //
}
/**
 * 移动端Header头
 */
function Header(props: IProps) {
  const {
    children, // header下面自定义的dom节点
    isShowBack = false, // 是否显示返回icon
    isShowMenu = false, // 是否显示菜单icon
    isShowCampusText = false, // 是否显示“校园招聘”文案,
    isShowSocialText = false, // 是否显示“社会招聘”文案
    isShowBeidouText = false,
    isShowQihangText = false,
    text = '', // 自定义的文案或dom
    isShowLogo = false,
    isShowSearch = false, // 是否显示搜索框
    searchPlaceHolder = '按关键词搜索岗位', // 搜索的placeHolder文案
    isSticky, // header是否吸顶
    searchValue = '', // 传入的搜索文案
    searchInputOnChangeCbFn = () => {}, // 传入的搜索文案
    searchCallbackFn = () => {}, // 点击搜索按钮自定义回调函数
    bgColor, // 背景颜色
    isShowPersonalCenter = true, // 是否展示个人中心
    backUrl = '', // 用户指定点击返回按钮返回的页面
    defaultBackUrl = '/home', // 当前没有历史的情况下，默认返回的页面，当前指定为'home'，用户可以自己指定返回到哪个默认页面
  } = props;
  // 登录相关
  const { loginStore, cmsData } = useRootStore();
  const { isLogin, userInfo } = loginStore || {};
  const { goBack, go } = useGo();
  const [isShowTipsDialog, setIsShowTipsDialog] = useState<boolean>(false);
  const [isShowNavBar, setIsShowNavBar] = useState<boolean>(false);
  const [inputSearchValue, setInputSearchValue] = useState<string>(searchValue);
  const textDesc = getText({
    isShowCampusText,
    isShowSocialText,
    isShowBeidouText,
    isShowQihangText,
    text,
    isShowLogo,
    setIsShowTipsDialog,
  });
  let type = '';
  let bid = '';
  if (isShowCampusText) {
    type = 'campus';
    bid = 'b_ead_w4f7lzkd_mc';
  }
  if (isShowBeidouText) {
    type = 'beidou';
  }
  if (isShowQihangText) {
    type = 'qihang';
  }
  if (isShowSocialText) {
    type = 'social';
    bid = 'b_ead_ay2g8i0v_mc';
  }
  const modalContent = cmsData.getSectionByName(SECTION_NAME_MAP.bannerDesc)?.find((item) => item.code === type) ?? {};
  function closeCampusDialog() {
    setIsShowTipsDialog(false);
  }
  function searchCallback() {
    if (!isFunction(searchCallbackFn)) {
      return;
    }
    searchCallbackFn(inputSearchValue);
  }

  useEffect(() => {
    setInputSearchValue(searchValue);
  }, [searchValue]);

  return (
    <div className={classnames('zp_header', { 'zp_header-sticky': isSticky })} style={{ backgroundColor: bgColor }}>
      <div className="content">
        {isShowMenu && (
          <div
            className="iconWrap"
            onClick={() => {
              LxSiteClick({ bid });
              setIsShowNavBar(true);
            }}
          >
            {menuIcon}
            {/* <img crossOrigin="anonymous" className="menu" src={menus} alt="菜单" /> */}
          </div>
        )}
        {isShowBack && (
          <div
            className="iconWrap"
            onClick={() => {
              if (backUrl) {
                go(backUrl, {
                  replace: true,
                });
              } else if (window?.history?.length === 1) {
                go(defaultBackUrl, {
                  replace: true,
                });
              } else {
                goBack();
                // const prePath = window.location.pathname;
                // go(defaultBackUrl, {
                //   replace: true,
                // });
                // 解决百度浏览器不能返回问题，勿删
                // setTimeout(() => {
                //   const currentPath = window?.location?.pathname;
                //   if (prePath === currentPath) {
                //     goBack();
                //   }
                // }, 0);
              }
            }}
          >
            <i className="iconfont-official-website-m icon-zp-mtdui-left backIcon" />
          </div>
        )}
        {textDesc}
        <div className="empty" />
        {isShowSearch && (
          <div className="searchWrap">
            <i className="iconfont-official-website-m icon-zp-daodianb-search searchIcon" />
            <input
              className="searchInput"
              type="text"
              id="m-keyword-search"
              maxLength={99}
              value={inputSearchValue}
              onKeyDown={(event) => {
                if (event && event.keyCode === 13) {
                  searchCallback();
                }
              }}
              onChange={(event) => {
                setInputSearchValue(event.target.value);
                if (isFunction(searchInputOnChangeCbFn)) {
                  searchInputOnChangeCbFn(event.target.value);
                }
              }}
              placeholder={searchPlaceHolder}
            />
            <button className="searchBtn" onClick={searchCallback}>
              搜索
            </button>
          </div>
        )}
      </div>
      {children}
      {/* 头部导航侧边栏 */}
      <Popup
        className="zp_header_navBar_popup"
        visible={isShowNavBar}
        onMaskClick={() => {
          setIsShowNavBar(false);
        }}
        position="left"
        bodyStyle={{ width: '58.666vw' }}
      >
        <NavBar
          isShowPersonalCenter={isShowPersonalCenter}
          isLogin={isLogin}
          userInfo={userInfo}
          goCallback={() => {
            setIsShowNavBar(false);
          }}
        />
      </Popup>
      <Modal
        className="zp_header_modal_campusTips_wrap"
        animation=""
        visible={isShowTipsDialog}
        disableAnimation
        onClose={() => {
          setIsShowTipsDialog(false);
        }}
      >
        <div className="zp_header_modal_campusTips">
          <span className="closeIcon_wrap" onClick={closeCampusDialog}>
            <i className="iconfont-official-website-m icon-zp-mtdui-close closeIcon" />
          </span>
          <div className="imgWrap">
            <img crossOrigin="anonymous" className="img" src={modalContent?.imgUrl} alt="" />
          </div>
          <div className="textWrap">
            <h5 className="title">{modalContent?.title}</h5>
            <div className="desc" dangerouslySetInnerHTML={{ __html: modalContent?.description }} />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default observer(Header);
